import type { Session } from '@/api/Sessions'
import environment from '@/helpers/Environment'
import { isTrueish } from '@/helpers/StringHelpers'
import { isLoggedIn } from '@/state/Authentication'
import type { CartItem, TimedItem } from '@/store/CartItem'
import store from '@/store/store'
import type { Moment } from 'moment-timezone/moment-timezone'

export function eventIsInCart(event: EventTemplate) {
  const items: CartItem[] = store.getters['Cart/cartItems']
  return items.some((item) => item.event.id === event.id)
}

export function citypassIsEnabled(event: EventWithMeta): boolean {
  return Boolean(
    // Disable CityPASS if logged in.
    !isLoggedIn() && environment.config.citypass_code_groups && isTrueish(event.meta.citypass),
  )
}

export function setVisitWindow(sessions: Session[]) {
  const config = environment.web.upsells?.visit_time
  const anchor = store.getters['Cart/anchor']
  if (config && anchor) {
    const [start, end] = calculateVisitWindow(config, anchor, sessions)
    store.commit('Cart/visitWindow', { start, end })
  }
}

function calculateVisitWindow(config: string, anchor: TimedItem, sessions: Session[]): [Moment, Moment] {
  const anchorStart = anchor.startMoment
  const anchorEnd = anchor.endMoment
  const dayStart = anchorStart.clone().startOf('day')
  const dayEnd = anchorStart.clone().endOf('day')
  const lastSession = sessions[sessions.length - 1]
  const anchorClose = lastSession.endMoment

  if (config === 'timeslot') {
    return [anchorStart, anchorEnd]
  } else if (config === 'same_start') {
    // Create a window of one minute. This is much simpler than modifying multiple API query builders to dynamically
    // support multiple query parameter modifiers;
    //   1. Less than, < ._lt
    //   2. Less than or equal to, <= ._lte
    // And it is good enough for an unused feature. As of November 2022 no tenants use the same_start option. That might
    // be because it did not work as documented.
    return [anchorStart, anchorStart.clone().add(1, 'minute')]
  } else if (config === 'same_date') {
    return [dayStart, dayEnd]
  } else if (config === 'until_close') {
    return [anchorStart, anchorClose]
  } else {
    throw new Error('Unsupported value for `upsells.visit_time` config: ' + config)
  }
}
